/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toAreaProps } from './translator/area'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchArea, FetchAreaMine, GetArea } from '@/infrastructure/network/Monitaro/requests/area'

export default class Area extends MonitaroGatewayBase {
  async FetchArea(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchArea(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.areas.map((prop) => toAreaProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchAreaMine(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchAreaMine(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.areas.map((prop) => toAreaProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetArea(id: string) {
    const { area } = await this.apiClient.request(new GetArea(id))
    return toAreaProps(area)
  }
}
